import { newId } from './ids.js';
import { clearStored, readStored, writeStored } from './storage.js';

const SESSION_KEY = 'visit';

export const SESSION_TIMEOUT_MS = 30 * 60 * 1000;

interface StoredSession {
  id: string;
  /** Client epoch millis, only ever compared against the same clock, so skew cancels. */
  at: number;
}

function liveSessionId(now: number): string | null {
  const raw = readStored(SESSION_KEY);
  if (!raw) {
    return null;
  }
  try {
    const { id, at } = JSON.parse(raw) as Partial<StoredSession>;
    return typeof id === 'string' && typeof at === 'number' && now - at < SESSION_TIMEOUT_MS ? id : null;
  } catch {
    return null;
  }
}

export function renewSession() {
  const now = Date.now();
  const id = liveSessionId(now) ?? newId();
  writeStored(SESSION_KEY, JSON.stringify({ id, at: now } satisfies StoredSession));
}

export function readSessionId(): string | null {
  return liveSessionId(Date.now());
}

/** @internal — test-only reset */
export function _resetSession() {
  clearStored(SESSION_KEY);
}
